import { User } from './auth';
import { ProductModel, QuestionOption } from './product';

export const DAY_OF_LABEL: Record<number, string> = {
  1: '월요일',
  2: '화요일',
  3: '수요일',
  4: '목요일',
  5: '금요일',
  6: '토요일',
  7: '일요일',
};
export const WEEK_OF_LABEL: Record<number, string> = {
  1: '첫째주',
  2: '둘째주',
  3: '셋째주',
  4: '넷째주',
  5: '마지막주',
};

interface RepeatDayOfWeek {
  dayOfWeek: number;
  time: string;
}

interface RepeatDayOfMonth {
  weekOfMonth: number;
  dayOfWeek: number;
  time: string;
}

export type PaymentTemplateSchedule = WeeklySchedule | MonthlySchedule;

export interface WeeklySchedule {
  type: 'weekly';
  repeatDayOfWeek: RepeatDayOfWeek[];
  duration?: number;
}

export interface MonthlySchedule {
  type: 'monthly';
  repeatDayOfMonth: RepeatDayOfMonth[];
  duration?: number;
}

export type PaymentTemplatePayment = WeeklyPayment | MonthlyPayment;

export interface WeeklyPayment {
  type: 'weekly';
  amount: number;
  paymentDayOfWeek: number;
}

export interface MonthlyPayment {
  type: 'monthly';
  amount: number;
  paymentDayOfMonth: number;
}

export interface PaymentTemplate {
  _id: string;
  name: string;
  partnerId: string;
  productId: string;
  schedule: PaymentTemplateSchedule;
  payment: PaymentTemplatePayment;
  questionOptions?: QuestionOption[];
  memo?: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface GetPaymentTemplate extends PaymentTemplate {
  product: ProductModel;
}

export interface PublishedUser {
  id: string;
  name: string;
  phone: string;
}

export interface PublishedPaymentTemplate {
  _id: string;
  paymentTemplateId: string;
  partnerId: string;
  users: PublishedUser[];
  startDate: Date;
  endDate: Date;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface GetPublishedPaymentTemplate extends PublishedPaymentTemplate {
  paymentTemplate: PaymentTemplate;
  partner: User;
}
